import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { StaffService } from '../../services/staff.service';
import { ErrorService } from '../../shared/services/error.service';
import { PayrollItem, PayrollSummary } from '../../models/Payroll';
import { TableColumn } from '../../shared/components/table/table.component';

@Component({
  selector: 'app-hr-payroll-center',
  templateUrl: './hr-payroll-center.component.html',
  styleUrls: ['./hr-payroll-center.component.css']
})
export class HrPayrollCenterComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();

  loading = false;
  error: string | null = null;

  month!: number;
  year!: number;

  summary: PayrollSummary | null = null;
  items: PayrollItem[] = [];

  columns: TableColumn[] = [
    { titulo: 'Funcionário', label: 'StaffName' },
    { titulo: 'Matrícula', label: 'Registration' },
    { titulo: 'Departamento', label: 'Department' },
    { titulo: 'Cargo', label: 'Position' },
    { titulo: 'Salário Base', label: 'BaseSalary' },
    { titulo: 'Salário Bruto', label: 'GrossSalary' },
    { titulo: 'Salário Líquido', label: 'NetSalary' },
    { titulo: 'Descontos', label: 'Discounts' },
    { titulo: 'Benefícios', label: 'Benefits' },
    { titulo: 'Dias Trab.', label: 'WorkDays' },
    { titulo: 'Faltas', label: 'AbsenceDays' }
  ];

  constructor(
    private staffService: StaffService,
    private errorService: ErrorService
  ) {}

  ngOnInit(): void {
    const today = new Date();
    this.month = today.getMonth() + 1;
    this.year = today.getFullYear();
    this.loadPayroll();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  loadPayroll(): void {
    if (!this.month || !this.year) {
      return;
    }

    this.loading = true;
    this.error = null;
    this.summary = null;
    this.items = [];

    this.staffService
      .getPayroll(this.month, this.year)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res) => {
          this.summary = res;
          this.items = res.Items || [];
          this.loading = false;
        },
        error: (err) => {
          this.loading = false;
          this.error = err?.message || 'Erro ao carregar folha salarial';
          this.errorService.handleHttpError(err);
        }
      });
  }

  onMonthChange(value: string): void {
    const num = Number(value);
    if (!Number.isNaN(num) && num >= 1 && num <= 12) {
      this.month = num;
      this.loadPayroll();
    }
  }

  onYearChange(value: string): void {
    const num = Number(value);
    if (!Number.isNaN(num) && num >= 1900) {
      this.year = num;
      this.loadPayroll();
    }
  }
}

